<div style="width: 100%;">
    <section class="engagement-preparation-navigation">
        <ul>
            <li (click)="loadChildComponent(0)" routerLinkActive="active" *ngIf="childComponent !== 0">
                <h5>Study Details</h5>
            </li>
            <li class="selected" *ngIf="childComponent === 0">
                <h5>Study Details</h5>
            </li>    
            <li (click)="loadChildComponent(1)" routerLinkActive="active" [ngClass]="{'selected' : childComponent === 1}">
                <h5>Manage Client User</h5>
            </li>        
        </ul>
    </section>
    <form [formGroup]="targetForm" *ngIf="childComponent==0" class="study-details-tab">
        <section class="sideRight-body">

        <div class="rde-container-fluid">
            <div class="study-detail-block">
                <div class="document-analysis-block">
                    <div class="study-head-dir">
                        <div class="rde-row head-row">
                            <div class="team-mem-row head-width">
                                <i class="fas fa-tag s-icon-size"></i>
                                <span><h5 class="study-details">Study Type</h5></span>
                            </div>
                            <div class="add-user-block">
                                <div class="study-flag-radiobuttons">
                                    <div *ngFor="let flagOption of engagementFlagOptions.options">
                                        <label class="chkbox-container">{{flagOption.value}}
                                            <input type="radio" name="selectFlag" [checked]="studyFlagOptionId==flagOption.id"
                                                (change)="flagOptionClick(flagOption.id)">
                                            <span class="chk-checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rde-row head-row">
                    <i class="fas fa-layer-group s-icon-size"></i> <span>
                        <h3 class="study-details">Study Details</h3>
                    </span>
                </div>
                <div class="input-field-block">
                    <div class="rde-row pl-3 read-block mb-2">
                        <div class="col-12">
                            <div class="hean-clientName">
                                <label class="rde-row mb-0" for="client-name">
                                    <span>Client Name:
                                        <input id="client-name"
                                            class="client-name-value opposite-colors no-input edit-label"
                                            placeholder="Client Name" type="text" formControlName="clientName"
                                            no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('clientName');"
                                            readonly="readonly" />
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="hean-engagementName">
                                <label class="rde-row mb-0" for="tax-year">
                                    <span>Tax Year:
                                        <input id="tax-year"
                                        class="tax-year-value opposite-colors no-input" type="text"
                                            no-special-chars="#!$%^<>+='" [value]="taxYear" readonly="readonly" />
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="rde-row row-center pl-3">
                        <div class="col-12 flex-grow">
                            <div class="rde-row sm-col">
                                <div class="sm-row gap-2">
                                    <div class="col-6 rde-col flex-grow">
                                        <label class="rde-row mb-0 sm-col" for="engagement-name">
                                            <div class="label-wrapper">
                                                <i class="far fa-asterisk star-style p-0 eng-star"></i> Study Name
                                                <span *ngIf="f.engagementName.errors">
                                                    <span class="required-error" *ngIf="f.engagementName.errors.required">(required)</span>
                                                </span>
                                            </div>

                                            <input
                                                id="engagement-name"
                                                class="black-input opposite-colors"
                                                placeholder="Required"
                                                type="text"
                                                no-special-chars="!$%^<>+='"
                                                (blur)="trimSpecialChar('engagementName');"
                                                formControlName="engagementName"
                                                (change)="onChangeEngagementName($event.target.value)"
                                                required
                                            />
                                        </label>
                                    </div>

                                    <div class="col-6 rde-col flex-grow">
                                        <label class="rde-row mb-0 sm-col" for="engagement-number">
                                            <div class="label-wrapper">
                                                <i class="far fa-asterisk star-style eng-star"></i> Engagement Number
                                                <span *ngIf="f.engagementNumber.errors">
                                                    <span class="required-error"
                                                        *ngIf="f.engagementNumber.errors.required">(required)</span>
                                                </span>
                                            </div>
                                            <input
                                                id="engagement-number"
                                                class="black-input opposite-colors"
                                                placeholder="Engagement Number" type="text"
                                                no-special-chars="#!$%^<>+='"
                                                (blur)="trimSpecialChar('engagementNumber');"
                                                formControlName="engagementNumber"
                                                (input)="checkEngagementNumber()"
                                                (change)="onChangeEngagementNumber($event.target.value)"
                                                required
                                            />
                                            <div class="form-error-sign"
                                                *ngIf="f.engagementNumber.errors && !f.engagementNumber.errors.required">
                                                <p>Alphanumeric Characters Only</p>
                                            </div>
                                        </label>
                                        <br>
                                    </div>
                                </div>
                                <div class="sm-row gap-2">
                                    <div class="col-6 sub-pad flex-grow">
                                        <label for="start-date">
                                            <i class="far fa-asterisk star-style"></i> TY Start Date
                                            <span *ngIf="f.engagementStartDate.errors">
                                                <span class="required-error"
                                                    *ngIf="f.engagementStartDate.errors.required">(required)</span>
                                            </span>
                                            <span class="input-group startdate-input">
                                                <input type="text" class="black-input opposite-colors engagement-datepicker"
                                                       id="start-date"
                                                    [attr.disabled]="check? true : null"
                                                    [ngClass]="{'ng-invalid': startDateError}" [bsValue]="defaultStartDate"
                                                    bsDatepicker [maxDate]="maxDate"
                                                    [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                    (bsValueChange)="setStartDate($event)"
                                                    formControlName="engagementStartDate" #dpStart="bsDatepicker"
                                                    (focus)="onfocStartDate()" />
                                                <span class="input-group-append cal-icon">
                                                    <!-- <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.engagementStartDate"
                                                                      (click)="clearStartDate()"></i> -->
                                                    <i class="fa fa-calendar-alt create-datepic"
                                                        (click)="openDatePickerStart()"></i>
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                    <div class="col-6 sub-pad flex-grow">
                                        <label for="end-date">
                                            TY End Date
                                            <span class="input-group enddate-input">
                                                <input type="text" class="black-input opposite-colors"
                                                       id="end-date"
                                                    [ngClass]="{'ng-invalid': startDateError}"
                                                    [attr.disabled]="check? true : null" [bsValue]="defaultEndDate"
                                                    bsDatepicker [maxDate]="maxDate" [minDate]="minDate"
                                                    [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                                    (bsValueChange)="setEndDate($event)" formControlName="engagementEndDate"
                                                    #dpEnd="bsDatepicker" (focus)="onfocEndDate()" />
                                                <span class="input-group-append cal-icon">
                                                    <!-- <i class="fas fa-times input-group-append-i" *ngIf="targetForm.value.engagementEndDate"
                                                                      (click)="clearEndDate()"></i> -->
                                                    <i class="fa fa-calendar-alt create-datepic"
                                                        (click)="openDatePickerEnd()"></i>
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-error-sign" *ngIf="startDateError">
                                <p>Start Date cannot be later than End Date</p>
                            </div>
                        </div>
                    </div>
                    <div class="rde-row">
                        <div class="sm-row gap-2 pad-sides flex-grow">
                            <div class="col-6 flex-grow">
                                <div *ngIf="!noengagementManager" class="hcne-engagementName mt-2">
                                    <label for="no-engagement-manager">
                                        <i class="far fa-asterisk star-style"></i> Engagement Manager
                                        <div class="input-elm">
                                            <input id="no-engagement-manager" [attr.disabled]="!noengagementManager"
                                                [class.no-input]="isReadonlyENo" class="black-input opposite-colors"
                                                type="text" no-special-chars="!$%^<>+='" formControlName="engagementManager"
                                                (blur)="trimSpecialChar('engagementName');" required />
                                            <!-- <span class="search-icon"><i class="fas fa-search"></i></span> -->
                                        </div>
                                    </label>
                                </div>
                                <div *ngIf="noengagementManager" class="hcne-engagementName mt-2">
                                    <label for="engagement-manager">
                                        <i class="far fa-asterisk star-style"></i> Engagement Manager
                                        <!-- <div class="input-elm">
                                        <input id="engagement-manager" formControlName="EngagementManager" class="black-input opposite-colors" placeholder="Engagement Manager" type="text" no-special-chars="!$%^<>+='" (blur)="trimSpecialChar('engagementName');"
                                            required   />
                                            <span class="search-icon"><i class="fas fa-search"></i></span>
                                        </div> -->

                                        <div class="input-elm">
                                            <input class="black-input opposite-colors kpmg-user-autocomplete" id="engagement-manager"
                                                placeholder="Enter a KPMG User Name" [disabled]="check"
                                                [ngClass]="{disabledText: check}" type="text" no-special-chars="#!$%^<>+="
                                                [kpmgUiTypeahead]="searchEngagementManagerStream" [resultTemplate]="rt"
                                                [editable]="false" [inputFormatter]="kpmgUserFormatter"
                                                (keydown)="searchKPMG(true)"
                                                (selectItem)="onEngagementManagerSelect($event)">
                                            <span class="search-icon"><i class="fas fa-search"></i></span>
                                        </div>
                                        <ng-template #rt let-r="result" let-t="term">
                                            <kpmg-ui-highlight *ngIf="engagementManagerKPMGUser"
                                                class="create-engagement-typeahead"
                                                [innerHtml]='finalEngagementManagerstrKPMG' [term]="t">
                                            </kpmg-ui-highlight>
                                            <kpmg-ui-highlight *ngIf="!engagementManagerKPMGUser" [title]="r.userName"
                                                class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                            </kpmg-ui-highlight>&nbsp;

                                        </ng-template>
                                    </label>
                                </div>
                                <div *ngIf="engagementManagerSelected && engagementManagerSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="engagementManagerSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': engagementManagerSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <button class="link-button" (click)="removeEngagementManagerSelected(row)">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="250">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                                <div *ngIf="noResultflag">
                                    <div>
                                        user is not found.
                                    </div>
                                    <div class="add-user-link">Add this user</div>
                                </div>
                            </div>
                            <div class="col-6 sub-padding flex-grow">
                                <div *ngIf="!noengagementPartner" class="hcne-engagementNumber mt-2">
                                    <label for="engagement-partner">
                                        <i class="far fa-asterisk star-style"></i> Engagement Partner
                                        <div class="input-elm">
                                            <input id="engagement-partner" [class.no-input]="isReadonlyENo"
                                                class="black-input opposite-colors" type="text"
                                                no-special-chars="#!$%^<>+='" [attr.disabled]="!noengagementPartner"
                                                formControlName="engagementPartner"
                                                (blur)="trimSpecialChar('engagementNumber');" required
                                                [ngClass]="{'ng-invalid': engagementNumberError}" />
                                            <!-- <span class="search-icon"><i class="fas fa-search"></i></span> -->
                                        </div>

                                    </label>
                                </div>
                                <div *ngIf="noengagementPartner" class="hcne-engagementName mt-2">
                                    <label for="no-engagement-partner">
                                        <i class="far fa-asterisk star-style"></i> Engagement Partner
                                        <!-- <div class="input-elm">
                                        <input id="eng-partner" formControlName="engagementPartner" class="black-input opposite-colors" placeholder="Engagement Partner" type="text" no-special-chars="#!$%^<>+='" (blur)="trimSpecialChar('engagementNumber');"
                                        required [ngClass]="{'ng-invalid': engagementNumberError}" />
                                            <span class="search-icon"><i class="fas fa-search"></i></span>
                                        </div> -->

                                        <div class="input-elm">
                                            <input class="black-input opposite-colors kpmg-user-autocomplete" id="no-engagement-partner"
                                                placeholder="Enter a KPMG User Name" [disabled]="check"
                                                [ngClass]="{disabledText: check}" type="text" no-special-chars="#!$%^<>+="
                                                [kpmgUiTypeahead]="searchEngagementPartnerStream" [resultTemplate]="eprt"
                                                [editable]="false" [inputFormatter]="kpmgUserFormatter"
                                                (keydown)="searchKPMG(true)"
                                                (selectItem)="onEngagementPartnerSelect($event)">
                                            <span class="search-icon"><i class="fas fa-search"></i></span>
                                        </div>
                                        <ng-template #eprt let-r="result" let-t="term">
                                            <kpmg-ui-highlight *ngIf="engagementPartnerKPMGUser"
                                                class="create-engagement-typeahead" [title]="r.userName"
                                                [innerHtml]='finalEngagementPartnerstrKPMG' [term]="t">
                                            </kpmg-ui-highlight>
                                            <kpmg-ui-highlight *ngIf="!engagementPartnerKPMGUser" [title]="r.userName"
                                                class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                            </kpmg-ui-highlight>&nbsp;

                                        </ng-template>

                                    </label>
                                </div>
                                <div *ngIf="engagementPartnerSelected && engagementPartnerSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="engagementPartnerSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': engagementPartnerSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <button class="link-button" (click)="removeEngagementPartnerSelected(row)">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </button>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="250">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                                <div *ngIf="noResultflag">
                                    <div>
                                        user is not found.
                                    </div>
                                    <div class="add-user-link">Add this user</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="rde-row pad-sides sm-col">
                        <div class="rde-row gap-2 xs-col">
                            <div class="col-6 flex-grow">
                                <div class="hcne-engagementEmailFrequency mt-2">
                                    <label for="email-frequency">
                                        <div class="label-wrapper">
                                            <i class="far fa-asterisk star-style eng-star"></i> Email Reminders
                                            <span
                                                *ngIf="f.engagementEmailFrequency.errors && (f.engagementEmailFrequency.touched || f.engagementEmailFrequency.dirty)">
                                                <span class="required-error"
                                                    *ngIf="f.engagementEmailFrequency.errors.required">(required)</span>
                                            </span>
                                        </div>
                                        <div class="input-elm email-remainder">
                                            <custom-dropdown [selectText]="emailReminderText" [isDisabled]="isArchivedStudy"
                                                [options]="emailReminderOptions"
                                                (optionSelectedEvent)="onEmailFrequencySelected($event)">
                                            </custom-dropdown>
                                            <div class="form-warning-sign" *ngIf="f.engagementEmailFrequency.value===0">
                                                <p class="mt-0">* Email reminder is disabled</p>
                                            </div>

                                            <div class="form-error-sign" *ngIf="!f.engagementEmailFrequency.valid && !isArchivedStudy">
                                                <p class="mt-0">Email Reminder Frequency should be between 0 to 10</p>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="rde-top-row">
                                <div class="hours-block col-6 hours-col1">
                                    <label>
                                        Total Hours
                                        <div>
                                            <input class="black-input opposite-colors" min="0" max="3500" value="2096" formControlName="totalHours" type="number"(keyup)="onHoursChanged()" onlyNumber>
                                        </div>
                                    </label>
                                </div>
                                <div class="hours-block col-6 hours-col2">
                                    <label>
                                        Standard Non-Working Hours
                                        <div>
                                            <input class="black-input opposite-colors" min="0" max="2096" value="120" formControlName="standardNonWorkingHours" type="number" (keyup)="onHoursChanged()" onlyNumber>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="rde-top-row">
                        <div class="col-12 sme-checkbox rde-col sm-row gap-2">
                            <label class="datatable-checkbox parent-checkbox kpmg-checkbox sme-checkbox-lable">
                                <input type="checkbox" (change)="allowSMEsToAddNewProjectsEvent($event.target.checked)" [checked]="canSMEAddProjects" />
                                <span class="checkbox-label">Allow SME to add new Projects, Activities, NQAs and NWT inside Time survey.</span>
                            </label>
                        </div></div>
                        <div class="rde-top-row">
                        <div class="col-12 sme-checkbox rde-col sm-row gap-2">
                            <label class="datatable-checkbox parent-checkbox kpmg-checkbox sme-checkbox-lable">
                                <input type="checkbox" (change)="allowSMEsToAddNewEmployeesEvent($event.target.checked)" [checked]="canSMEAddEmployees" />
                                <span class="checkbox-label">Allow SME to add/remove new Employees inside Time survey.</span>
                            </label>
                        </div></div>
                    <br>
                    <div class="rde-top-row">
                        <div class="hours-block col-6 hours-col1">
                        <label for="hcne-startDate">
                            Prior Year QRE
                            <div>
                                <input class="black-input opposite-colors" (keyup)="onQreChanged()"  formControlName="priorYearQre"  type="number" >
                            </div>
                        </label>
                        </div>
                    <div class="hours-block col-6 hours-col2">
                        <label for="hcne-endDate">
                            Estimated QRE
                            <div>
                                <input class="black-input opposite-colors" (keyup)="onQreChanged()" formControlName="estimatedQre" type="number" >
                            </div>
                        </label>
                    </div>
            </div>
        </div>
    </div>
    
</div>

            <div class="team-members-block">
                <div class="rde-row head-row">
                    <div class="col-6 team-mem-row no-padding">
                        <i class="fas fa-user-friends s-icon-size"></i> <span>
                            <h3 class="study-details team-member-header">Team Members</h3>
                        </span>
                    </div>
                    <div class="col-6">

                    </div>
                </div>
                <div class="rde-row add-user-sec">
                    <div class="col-6 flex-grow">
                        <div class="add-user-block">
                            <label for="hcne-clients">Add KPMG Users</label>
                            <div class="hcne-kpmg-users">
                                <div class="input-with-icon mt-2">
                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            [disabled]="check" [ngClass]="{disabledText: check}"
                                            placeholder="Enter a KPMG User Name" type="text"
                                            no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="searchUserStream"
                                            [resultTemplate]="rtKPMG" [editable]="false"
                                            [inputFormatter]="kpmgUserFormatter" (keydown)="searchKPMG(true)"
                                            (selectItem)="onKPMGUserSelect($event)" (click)="searchKPMG(true)"
                                            (contextmenu)="searchKPMG(true)">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #rtKPMG let-r="result" let-t="term">
                                        <kpmg-ui-highlight *ngIf="adKPMGUser" class="create-engagement-typeahead"
                                            [innerHtml]='finalstrKPMG' [term]="t">
                                        </kpmg-ui-highlight>
                                        <kpmg-ui-highlight *ngIf="!adKPMGUser" [title]="r.userName"
                                            class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;
                                        <!-- <kpmg-ui-highlight class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                              </kpmg-ui-highlight> -->

                                    </ng-template>

                                </div>

                                <div *ngIf="kpmgUsersSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="kpmgUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': kpmgUsersSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <span class="link-button trash__btn" (click)="removeKPMGUser(row)"
                                                    tabindex="1" [attr.disabled]="check? true : null"
                                                    *ngIf="currentUserEmail!==row.email && engagementManager!=row.userId && engagementPartner!=row.userId">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </span>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="280">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <!-- <ngx-datatable-column [width]="30">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                          <span class="link-button trash__btn" (click)="removeKPMGUser(row)" tabindex="1"
                                                          *ngIf="currentUserEmail!==row.email">
                                                          <i class="fas fa-trash fail-color"></i>
                                                        </span>
                                                        </ng-template>
                                                    </ngx-datatable-column> -->
                                    </ngx-datatable>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div class="col-6 sub-padding flex-grow">
                        <div class="add-user-block">
                            <label for="hcne-clients">Add Client Managers</label>
                            <div class="hcne-kpmg-clientusers">
                                <div class="input-with-icon mt-2">
                                    <div class="input-elm">
                                        <input class="black-input opposite-colors kpmg-user-autocomplete"
                                            [disabled]="check" [ngClass]="{disabledText: check}"
                                            placeholder="Enter a Client User Name" type="text"
                                            no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="searchUserStream"
                                            [resultTemplate]="rt" [editable]="false"
                                            [inputFormatter]="clientUserFormatter" (keydown)="searchKPMG(false)"
                                            (click)="searchKPMG(false)" (contextmenu)="searchKPMG(false)"
                                            (selectItem)="onClientUserSelect($event)">
                                        <span class="search-icon"><i class="fas fa-search"></i></span>
                                    </div>
                                    <ng-template #rt let-r="result" let-t="term">
                                        <kpmg-ui-highlight *ngIf="adClientUser" class="create-engagement-typeahead"
                                            [innerHtml]='finalstrClient' [term]="t">
                                        </kpmg-ui-highlight>
                                        <kpmg-ui-highlight *ngIf="!adClientUser" [title]="r.userName"
                                            class="create-engagement-typeahead" [result]="r.displayName" [term]="t">
                                        </kpmg-ui-highlight>&nbsp;
                                    </ng-template>
                                </div>

                                <div *ngIf="clientUsersSelected.length > 0" class="mt-2">
                                    <ngx-datatable
                                        class="primary-ngx-datatable-styling create-new-engagement-sidebar-styling add-user-table"
                                        [rows]="clientUsersSelected" [headerHeight]="0" [rowHeight]="35"
                                        [ngStyle]="{'height': clientUsersSelected.length * 45 +'px' }">
                                        <ngx-datatable-column [width]="30">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <span class="link-button trash__btn" (click)="removeClientUser(row)"
                                                    [attr.disabled]="check? true : null">
                                                    <i class="fas fa-times cross-i-style"></i>
                                                </span>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column prop="name" [width]="250">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.displayName}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div class="hcne-archived mt-2">

            <label class="archive-checkbox">
                <toggle-switch [switchState]="check" (toggleState)="masterCheckboxaction($event)"></toggle-switch><span>
                    Archive Study</span>
            </label>
        </div>

    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success"
            [disabled]="!targetForm.valid || startDateError || isDisabled || engagementManagerSelectedId == 0 || engagementPartnerSelectedId == 0 || studyFlagOptionId === 0 || engagementNumberError || engagementNameError"
            (click)="updateEngagement()">
            Update
        </button>
        <button type='button' class="btn kpmg-button--flat"
            (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
    </footer>
</form>
<div *ngIf="childComponent==1" style="height: 100%;">
    <client-user-management [clientId]="clientId" (drawerWidthMangerClientUser)="drawerWidthHandler($event)"></client-user-management>
</div>
</div>
